import PageHeader from "@/components/PageHeader";
import { Reveal, Eyebrow } from "@/components/primitives";
import WhyUs from "@/components/sections/WhyUs";
import AssessmentCTA from "@/components/sections/AssessmentCTA";

const CHAPTERS = [
    {
        n: "01",
        title: "Understand operations",
        body: "We start by learning how work actually flows through your business, not how the org chart says it should.",
    },
    {
        n: "02",
        title: "Identify bottlenecks",
        body: "We find the repetitive, high-volume work that quietly consumes your team's time and attention.",
    },
    {
        n: "03",
        title: "Automate repetitive work",
        body: "We remove that work with practical automation built around your existing systems, not around ours.",
    },
    {
        n: "04",
        title: "Empower people",
        body: "So your team can focus on decisions that require experience, judgement and relationships.",
    },
];

export default function About() {
    return (
        <>
            <PageHeader
                eyebrow="About"
                titleLines={[
                    "AI should remove",
                    "repetitive work,",
                    "not replace people.",
                ]}
                description="harbrflow is an AI automation partner for shipping and logistics. We remove repetitive operational work so teams can focus on judgement and relationships."
            />

            <section className="py-24 md:py-32">
                <div className="mx-auto max-w-7xl px-6 lg:px-10">
                    <div className="grid gap-14 lg:grid-cols-12">
                        <div className="lg:col-span-5">
                            <div className="lg:sticky lg:top-28">
                                <Reveal>
                                    <Eyebrow>Our Philosophy</Eyebrow>
                                </Reveal>
                                <Reveal delay={0.05}>
                                    <p className="mt-6 text-2xl font-semibold leading-snug tracking-tight md:text-3xl">
                                        Businesses don&apos;t need more software.
                                        They need less manual work.
                                    </p>
                                </Reveal>
                                <Reveal delay={0.1}>
                                    <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
                                        We&apos;re not selling AI, and we&apos;re
                                        not selling software. We&apos;re helping
                                        shipping and logistics companies transform
                                        how their operations run. Our philosophy
                                        is simple.
                                    </p>
                                </Reveal>
                            </div>
                        </div>

                        <div className="lg:col-span-6 lg:col-start-7">
                            <div className="space-y-10">
                                {CHAPTERS.map((c) => (
                                    <Reveal key={c.n} delay={0.05}>
                                        <div className="border-t border-border pt-8">
                                            <span className="font-mono text-sm text-navy">
                                                {c.n}
                                            </span>
                                            <h3 className="mt-3 text-2xl font-semibold tracking-tight md:text-3xl">
                                                {c.title}
                                            </h3>
                                            <p className="mt-4 text-lg leading-relaxed text-muted-foreground">
                                                {c.body}
                                            </p>
                                        </div>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <WhyUs />
            <AssessmentCTA />
        </>
    );
}
